import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {FormArrayInputComponent} from "./form-array-input.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ConfirmationButtonModule} from "../../button/confirmation-button/confirmation-button.module";
import {ContentDirective} from "../../../../shared/directives/content.directive";
import {ContentModule} from "../../../../shared/directives/content.module";
import {ButtonModule} from "../../../../modules/core/component/button/button.module";
import {CardModule} from "../../../../modules/core/component/card/card.module";
import {ActionLinkModule} from "../../../../modules/core/component/action-link/action-link.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        ConfirmationButtonModule,
        ContentModule,
        ButtonModule,
        CardModule,
        ActionLinkModule,
    ],
    declarations: [
        FormArrayInputComponent,
    ],
    exports: [
        FormArrayInputComponent,
        ContentDirective,
    ],
})
export class FormArrayInputModule {}
